import { SVGInterface } from "../../interface";
const ContentFavorite = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.472 18L12 16.4295L9.528 18L10.184 15.04L8 13.0484L10.876 12.7916L12 10L13.124 12.7916L16 13.0484L13.816 15.04L14.472 18Z"
      fill={color || "#0E171F"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.82 3H19C20.1 3 21 3.9 21 5V21C21 22.1 20.1 23 19 23H5C3.9 23 3 22.1 3 21V5C3 3.9 3.9 3 5 3H9.18C9.6 1.84 10.7 1 12 1C13.3 1 14.4 1.84 14.82 3ZM13 4C13 3.45 12.55 3 12 3C11.45 3 11 3.45 11 4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4ZM5 5V21H19V5H17V8H7V5H5Z"
      fill={color || "#0E171F"}
    />
  </svg>
);
export default ContentFavorite;
